import { faqs } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-800 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-500">关于哺乳和育儿的常见疑问，这里都有答案</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">{faq.question}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-add-line text-foreground-400 group-open:hidden text-lg"></i>
                  <i className="ri-subtract-line text-primary-500 hidden group-open:block text-lg"></i>
                </div>
              </summary>
              <div className="px-6 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}